import { React, useEffect, useState } from "react";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import { useHistory, useLocation } from "react-router-dom";
import FormatListNumberedIcon from "@mui/icons-material/FormatListNumbered";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { LoaderScreen } from "../../components/LoaderScreen";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import EditIcon from '@mui/icons-material/Edit';
import request from "../../../Helpers/API";
import { AgregarModeloModal } from "./AgregarModeloModal";
import CollectionsIcon from '@mui/icons-material/Collections';
import { CarruselImagenesModal } from "./CarruselImagenesModal";
import { EditarModeloModal } from "./EditarModeloModal";
import Swal from "sweetalert2";
import { FormatMoney } from "../../../Helpers/FormatNumber";
import { capitalizePalabras } from "../../../Helpers/CapitalizePalabras";
import { Autocomplete, Button, Modal, Box, TextField, MenuItem, InputAdornment, FormControl, InputLabel, Select } from "@mui/material";
import { CaracteristicasModal } from "./CaracteristicasModal";
import AgricultureIcon from '@mui/icons-material/Agriculture';

export const ModelosListadoScreen = () => {
    const history = useHistory();
    const { state } = useLocation();
    const [modelos, setModelos] = useState([]);
    const [openModal, setOpenModal] = useState(false);
    const [openModalEditar, setOpenModalEditar] = useState(false);
    const [openCracteristicasModal, setOpenCaracteristicasModal] = useState(false);
    const [openModalCarrusel, setOpenModalCarrusel] = useState(false);
    const [idmodeloselect, setidModeloSelect] = useState();
    const [caracteristicasSelect, setCaracteristicasSelect] = useState();
    const [modeloselect, setModeloSelect] = useState();
    const [estado, setEstado] = useState(false);
    const [lineaSeleccionada, setLineaSeleccionada] = useState(1);
    const [departamentoLinea, setDepartamentoLinea] = useState(null);
    const [lineasDisponibles, setLineasDisponibles] = useState([]);

    const handleLineaChange = (event) => {
        const nuevaLinea = event.target.value;
        setLineaSeleccionada(nuevaLinea);

        const linea = lineasDisponibles.find(l => l.idlinea === nuevaLinea);
        if (linea) {
            setDepartamentoLinea(linea.iddepartamento);
        } else {
            setDepartamentoLinea(null);
        }
    };

    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });

    const handleOpenModal = () => {
        setOpenModal(true);
    };

    const handleCloseModal = () => {
        setOpenModal(false);
    };

    const handleOpenModalEditar = (id) => {
        setidModeloSelect(id);
        setOpenModalEditar(true);
    };

    const handleCloseModalEditar = () => {
        setidModeloSelect(null)
        setOpenModalEditar(false);
    };

    const handleOpenCaracteristicasModal = (caracteristicas, modelo) => {
        setModeloSelect(modelo);
        setCaracteristicasSelect(caracteristicas);
        setOpenCaracteristicasModal(true);
    };

    const handleCloseCaracteristicasModal = () => {
        setModeloSelect(null);
        setCaracteristicasSelect(null);
        setOpenCaracteristicasModal(false);
    };
    // console.log(modelos)
    const handleOpenCarrusel = async (idmodelo, imagen) => {

        if (imagen === "N") {
            return
        }
        else {
            setidModeloSelect(idmodelo)
            setOpenModalCarrusel(true);

        }

    };

    const handleCloseCarrusel = () => {
        setidModeloSelect(null)
        setOpenModalCarrusel(false);
    };

    useEffect(() => {
        const fetchData = async () => {
            setLoader(prev => ({ ...prev, mostrar: true }));

            try {
                const requests = [
                    request.get(`ListadoModelos/Modelos`),
                    request.get(`ListadoModelos/LineasDropDownList`)
                ];

                const [result1, result2] = await Promise.all(requests);

                setModelos(result1);
                setLineasDisponibles(result2);
            } catch (error) {
                Swal.fire("Error", "Ocurrió un error al cargar los datos.", "error");
            } finally {
                setLoader(prev => ({ ...prev, mostrar: false }));
            }
        };

        fetchData();
    }, [openModal, openModalEditar, estado]);


    const convertirJSON = (jsonString) => {
        try {
            const caracteristicas = JSON.parse(jsonString);
            return caracteristicas.map((c, i) => (
                <span key={i}>
                    {c.descripcion}
                    <br />
                </span>
            ));
        } catch (err) {
            return <span>-</span>; // Por si el JSON no es válido
        }
    };

    const CambiarEstado = (idmodelo) => {
        setLoader({ ...loader, mostrar: true });
        request
            .get(
                `ListadoModelos/CambiarEstado?idmodelo=${idmodelo}`
            )
            .then((result) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire({
                    title: "MODELOS",
                    text: "Estado modificado con éxito",
                    icon: "success",
                    customClass: {
                        container: "mi-superpoop",
                    },
                });
                setEstado(prev => !prev);
                return;
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                return;
            });
    };

    // console.log(lineasDisponibles)

    return (
        <PlantillaScreen
            titulo={`MODELOS`}
            className={"modelos-main-screen"}
            className_main={1}
        >
            <div className="modelos-actions">
                <div
                    className="modelos-actions-regresar"
                    onClick={() => history.goBack()}
                >
                    <ArrowBackIcon /> Regresar
                </div>
                <div className="buttons">
                    <button className="modelos-header-agregar-linea"
                        onClick={() => handleOpenModal()}
                    >
                        <AddCircleOutlineIcon /> Agregar
                    </button>
                </div>
            </div>
            <div className="modelos">
                <LoaderScreen loader={loader} />
                <div className="modelos-filtro">
                    <FormControl fullWidth size="small" sx={{ mb: 2 }}>
                        <InputLabel id="linea-select-label">Mostrar Línea</InputLabel>
                        <Select
                            labelId="linea-select-label"
                            value={lineaSeleccionada}
                            label="Filtrar por Línea"
                            onChange={handleLineaChange}
                        >
                            {lineasDisponibles.map((linea, index) => (
                                <MenuItem key={linea.idlinea} value={linea.idlinea}>
                                    {capitalizePalabras(linea.descripcion)}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </div>
                <div className="modelos-header">
                    {/* <div className="modelos-header-title">
                        <FormatListNumberedIcon /> Listado de Modelos Registrados
                    </div> */}
                </div>
                <div className="modelos-container scroll-4">
                    <table>
                        <thead>
                            <tr>
                                <th></th>
                                <th>
                                    <div>Modelo</div>
                                </th>
                                <th>
                                    <div>Descripcion</div>
                                </th>
                                {departamentoLinea === 3 && (
                                    <>
                                        <th><div>Costo Refacciones</div></th>
                                        <th><div>Costo Servicios</div></th>
                                    </>
                                )}
                                <th>
                                    <div>Precio</div>
                                </th>
                                <th>
                                    <div>Moneda</div>
                                </th>
                                <th>
                                    <div>Categoria</div>
                                </th>
                                <th>
                                    <div>Estatus</div>
                                </th>

                                <th>
                                    <div>Editar</div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {modelos
                                .filter((mo) => !lineaSeleccionada || mo.idlinea === lineaSeleccionada)
                                .map((mo) => (
                                    <tr key={mo.idmodelo}>
                                        <td className="celda-foto">
                                            <div
                                                className={mo.tiene_fotografia === "S" ? "img" : "img-sin-color"}
                                                onClick={() => {
                                                    if (mo.tiene_fotografia === "S") {
                                                        handleOpenCarrusel(mo.idmodelo, mo.tiene_imagen);
                                                    }
                                                }}
                                            >
                                                <CollectionsIcon />
                                            </div>
                                        </td>

                                        {/* <td className="celda-carac-buton">
                                            
                                        </td> */}
                                        <td className="celda-modelo">
                                            <div className="celda-modelo-container">
                                                <div
                                                    className={mo.caracteristicas ? "img" : "img-sin-color"}
                                                    onClick={() => {
                                                        if (mo.caracteristicas) {
                                                            handleOpenCaracteristicasModal(convertirJSON(mo.caracteristicas), mo.modelo);
                                                        }
                                                    }}
                                                >
                                                    <AgricultureIcon />
                                                </div><div>{mo.modelo}</div>
                                            </div></td>
                                        <td className="celda-descripcion">{mo.mdl_descripcion}</td>
                                        {departamentoLinea === 3 && (
                                            <>
                                                <td className="celda-importe">{FormatMoney(mo.costo_refacciones)}</td>
                                                <td className="celda-importe">{FormatMoney(mo.costo_servicios)}</td>
                                            </>
                                        )}
                                        <td className="celda-importe">{FormatMoney(mo.precio_lista)}</td>
                                        <td className="ta-center celda-moneda">{mo.moneda}</td>
                                        <td className="celda-modelo">{mo.categoria_descripcion}</td>
                                        <td className="celda-estatus" onClick={() => CambiarEstado(mo.idmodelo)}>
                                            {mo.estatus === 0 ? (
                                                <RemoveCircleIcon sx={{ color: "#7b7b7b" }} />
                                            ) : (
                                                <CheckCircleIcon sx={{ color: "#5aa05b" }} />
                                            )}
                                        </td>
                                        <td className="celda-editar">
                                            <div className="modelos-acciones-listado">
                                                <div
                                                    className="boton-editar-modelos"
                                                    onClick={() => handleOpenModalEditar(mo.idmodelo)}
                                                >
                                                    <EditIcon /> Editar
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                        </tbody>
                    </table>
                </div>
                <AgregarModeloModal
                    open={openModal}
                    onClose={handleCloseModal}
                    lineaSelect={lineaSeleccionada}
                    departamento={departamentoLinea}
                //   folio={folio}
                />
                <EditarModeloModal
                    open={openModalEditar}
                    onClose={handleCloseModalEditar}
                    id={idmodeloselect}
                    departamento={departamentoLinea}
                />
                <CaracteristicasModal
                    open={openCracteristicasModal}
                    onClose={handleCloseCaracteristicasModal}
                    modelo={modeloselect}
                    caracteristicas={caracteristicasSelect}
                />
                <CarruselImagenesModal open={openModalCarrusel} handleClose={handleCloseCarrusel} idmodeloselect={idmodeloselect} />

            </div>
        </PlantillaScreen>
    );
};
